(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-spare"]) return;
  try {
    
  const wishlist = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]');
  console.log('PROCO');
  console.log(wishlist);
  if (wishlist.length > 3) {
    const raw = document.querySelector('html').dataset.root + '/';
    const prefix = raw.replace(/\/{2,}/g, '/');
    Promise.all(wishlist.map((handle) => fetch(`${prefix}products/${handle}?view=card`).then((res) => res.text())))
      .then((products) => {
        const container = document.getElementById('recently-container');
        if (products.length > 0) {
          products.reverse().forEach((prod) => {
            container.insertAdjacentHTML('beforeend', prod);
          });
        }
      })
      .then(() => {
        document.querySelector('.recent_products').classList.remove('hidden');
        window.dispatchEvent(new CustomEvent('product-card'));
        window.dispatchEvent(new CustomEvent('quick-buy'));
        window.dispatchEvent(new CustomEvent('wishlist'));
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  const recent = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]');

  function renderProducts(handles, containerId) {
    if (handles.length === 0) return Promise.resolve();
    const raw = document.querySelector('html').dataset.root + '/';
    const prefix = raw.replace(/\/{2,}/g, '/');
    return Promise.all(
      handles.map((handle) => fetch(`${prefix}products/${handle}?view=card`).then((res) => res.text()))
    ).then((products) => {
      const container = document.getElementById(containerId);
      if (products.length > 0) {
        products.reverse().forEach((prod) => {
          container.insertAdjacentHTML('beforeend', prod);
        });
      }
    });
  }

  function dispatchProductEvents() {
    window.dispatchEvent(new CustomEvent('product-card'));
    window.dispatchEvent(new CustomEvent('quick-buy'));
    window.dispatchEvent(new CustomEvent('wishlist'));
  }
  

  if (recent.length > 3 && wishlist.length === 0) {
    renderProducts(recent, 'recently-container').then(() => {
      document.querySelector('.recent_products').classList.remove('hidden');
      const msg = document.querySelector('[data-js="message"]')
      msg.innerHTML = msg.dataset.message;
      document.querySelector('.wishlist_loader').remove()
      dispatchProductEvents();
    });
  } else if ( wishlist.length === 0 ) {
      document.querySelector('[data-js="wishlist_top"]').classList.add("min-h-[100vh]")
      const msg = document.querySelector('[data-js="message"]')
      msg.innerHTML = msg.dataset.message;
      document.querySelector('.wishlist_loader').remove()
  }

  if (wishlist.length > 0) {
    renderProducts(wishlist, 'wishlist-container').then(() => {
      const container = document.getElementById('wishlist-container');
      container.classList.remove('hidden');
      dispatchProductEvents();
      document.querySelector('.wishlist_loader').remove()
      document.querySelectorAll('[data-js="product-card__wishlist"]').forEach((btn) => {
        btn.addEventListener('click', () => window.location.reload());
      });
    });
  }

  document.querySelector('[data-js="wishlist-clear"]')?.addEventListener('click', () => {
    localStorage.removeItem('wishlist');
    window.location.replace('/');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-selector"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const languageButtons = document.querySelectorAll('a[data-locale]');
    const countryButtons = document.querySelectorAll('a[data-locales]');
    const langSelect = document.querySelector('[data-js="store-selector-select-lang"]');
    const countrySelect = document.querySelector('[data-js="store-selector-select-country"]');
    const submitButton = document.querySelectorAll('[data-js="store-selector-submit"]');

    let activeUrl = null;
    let activeLang = 'en';
    let activeCode = null;
    let currentStore = document.querySelector('html').dataset.store;

    function deleteCookie(name) {
      document.cookie = name + '=; Max-Age=0; path=/; domain=.alessi.com';
    }
    deleteCookie('redirect_store_settings_v3');

    function buildHrefWithLang(baseHref, lang, code) {
      lang = lang.toLowerCase();

      const supportedLangs = ['en', 'it', 'fr', 'de', 'es'];
      let path = window.location.pathname;

      // Rimuove il prefisso lingua se presente (es. "/it/product" → "/product")
      const langPrefixRegex = new RegExp(`^/(${supportedLangs.join('|')})(/|$)`, 'i');
      path = path.replace(langPrefixRegex, '/');

      const query = `?loc=${code}&lang=${lang.toUpperCase()}`;

      if (lang === 'en') {
        return `${baseHref}${path}${query}`;
      } else {
        return `${baseHref}/${lang}${path}${query}`.replace(/([^:]\/)\/+/g, '$1');
      }
    }

    function updateLanguagesForStore(supportedLocalesRaw) {
      const supported = supportedLocalesRaw
        .split(',')
        .map((l) => l.trim().toLowerCase())
        .filter(Boolean);

      languageButtons.forEach((langBtn) => {
        const locale = langBtn.dataset.locale.toLowerCase();
        const isSupported = supported.includes(locale);
        langBtn.parentNode.classList.toggle('hidden', !isSupported);
        langBtn.classList.toggle('hidden', !isSupported);

        langBtn.addEventListener('click', () => {
          languageButtons.forEach((el) => el.classList.remove('active'));
          langBtn.classList.add('active');
          activeLang = locale;

          const href = buildHrefWithLang(activeUrl, activeLang, activeCode);
          submitButton.forEach((button) => {
            button.href = href;
          });
        });
      });

      if (langSelect) {
        Array.from(langSelect.options).forEach((option) => {
          const optionLocale = option.value.toLowerCase();
          option.disabled = !supported.includes(optionLocale);
        });
      }
    }

    countryButtons.forEach((countryBtn) => {
      countryBtn.addEventListener('click', (event) => {
        event.preventDefault();
        countryButtons.forEach((el) => el.classList.remove('active'));
        languageButtons.forEach((langBtn) => langBtn.classList.remove('active'));

        event.target.classList.add('active');
        activeCode = countryBtn.dataset.code;
        activeUrl = countryBtn.dataset.href;

        const href = buildHrefWithLang(activeUrl, activeLang, activeCode);
        submitButton.forEach((button) => {
          button.href = href;
        });

        const supportedLocales = countryBtn.dataset.locales || '';
        updateLanguagesForStore(supportedLocales);
      });
    });

    if (countrySelect) {
      countrySelect.addEventListener('change', (event) => {
        const selectedOption = event.target.selectedOptions[0];
        const langSelectInputs = langSelect.querySelectorAll('option');
        langSelect.value = langSelectInputs[0].value;

        activeCode = selectedOption.dataset.code || null;
        activeUrl = selectedOption.dataset.href || null;

        const supportedLocales = selectedOption.dataset.locales || '';
        updateLanguagesForStore(supportedLocales);

        const href = buildHrefWithLang(activeUrl, activeLang, activeCode);
        submitButton.forEach((button) => {
          button.href = href;
        });
      });
    }

    langSelect.addEventListener('change', (event) => {
      const locale = event.target.value.toLowerCase();
      activeLang = locale;

      const href = buildHrefWithLang(activeUrl, activeLang, activeCode);
      submitButton.forEach((button) => {
        button.href = href;
      });
    });

    const initial = document.querySelector(`[data-code="${currentStore}"]`);
    if (initial) {
      const locales = initial.dataset.locales || '';
      activeUrl = initial.dataset.href || null;
      updateLanguagesForStore(locales);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
